import dayjs from 'dayjs';

export function formatDate(time, format = 'YYYY-MM-DD HH:mm:ss') {
  return time ? dayjs(time).format(format) : '—';
}

export function numberFormat(number, decimals = 2, dec_point, thousands_sep, roundtag) {
  // eslint-disable-line
  number = (number + '').replace(/[^0-9+-Ee.]/g, '');
  roundtag = roundtag || 'round'; //"ceil","floor","round"
  let n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
    sep = typeof thousands_sep === 'undefined' ? ',' : thousands_sep,
    dec = typeof dec_point === 'undefined' ? '.' : dec_point,
    s = '',
    toFixedFix = function (n, prec) {
      let k = Math.pow(10, prec);
      return (
        '' + parseFloat(Math[roundtag](parseFloat((n * k).toFixed(prec * 2))).toFixed(prec * 2)) / k
      );
    };
  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
  let re = /(-?\d+)(\d{3})/;
  while (re.test(s[0])) {
    s[0] = s[0].replace(re, '$1' + sep + '$2');
  }

  if ((s[1] || '').length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1).join('0');
  }
  return s.join(dec);
}

export function formatFilesData(data) {
  return (data||[]).map(item => {
    return {
      url: item.url,
      uid: item.uid,
      size: item.size,
      status: item.status
    }
  })
}

export function isVideo(fileName) {
  return /\.(mp4|mov|avi|wmv|flv|webm)$/i.test(fileName);
}